import { render, staticRenderFns } from "./change-sa.vue?vue&type=template&id=02098674&lang=pug&"
import script from "./change-sa.vue?vue&type=script&lang=js&"
export * from "./change-sa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports